<template>
  <div :class="{show: visible}" class="loading-mini-container d-flex justify-content-center align-items-center">
    <UiSpinner/>
  </div>
</template>

<script>
import UiSpinner from "./UiSpinner.vue";

export default {
  name: 'loadingmini',
  components: {
    UiSpinner
  },

  data() {
    return {
      visible: false,
      start: null
    }
  },

  methods: {
    show: function () {

      this.visible = true;
    },

    hide: function () {
      this.visible = false
    },

  }


}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';

.loading-mini-container {
  background-color: rgba($main-white, 0.95);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  //transform: scale(0);
  z-index: $z-messages - 25;
  transition-property: opacity;


  &.show {
    opacity: 1;
    pointer-events: auto;
    //transform: scale(1);
  }
}
</style>
